<div class="modal-header py-2 bg-dark text-light">
    <h4 class="modal-title">
        ETAS차량관리
    </h4>
</div>

<div class="modal-body">
    <form [formGroup]="formGroup" (ngSubmit)="onSubmit()">
        <div class="form-group row align-items-center">
            <label class="col-md-3 mb-0">
                사업자번호
            </label>
            <div class="col-md-9 position-relative">
                <input type="text" class="form-control form-control-sm"
                    formControlName="dtgEid"
                    [readonly]="true">
            </div>
        </div>

        <div class="form-group row align-items-center">
            <label class="col-md-3 mb-0">
                단말번호
            </label>
            <div class="col-md-9 position-relative">
                <input type="text" class="form-control form-control-sm"
                    formControlName="dtgUnitId"
                    [readonly]="true">
            </div>
        </div>

        <div class="form-group row align-items-center">
            <label class="col-md-3 mb-0">
                업로드여부
            </label>
            <div class="col-md-9 position-relative">
                <select class="form-control form-control-sm w-auto"
                    formControlName="useYn">
                    <option [ngValue]="'Y'">사용</option>
                    <option [ngValue]="'N'">미사용</option>
                </select>
            </div>
        </div>

        <div class="form-group row align-items-center">
            <label class="col-md-3 mb-0">
                마지막업로드
            </label>
            <div class="col-md-9 position-relative">
                <input type="date" class="form-control form-control-sm"
                    formControlName="lastUpDt"
                    ngbAutofocus>
            </div>
        </div>
    </form>
</div>

<div class="modal-footer">
    <button type="button" class="btn btn-outline-success btn-sm"
        (click)="clickSave()"
        [hidden]="dtgActionType === DtgActionType.read">
        <i class="mdi mdi-content-save"></i>
        <span class="ml-1">
            저장
        </span>
    </button>
    <button type="button" class="btn btn-secondary btn-sm"
        (click)="clickCancel()">
        <i class="mdi mdi-close"></i>
        <span class="ml-1">
            취소
        </span>
    </button>
</div>
